import React, { createContext, useContext } from 'react';
const FormContext = /*#__PURE__*/createContext({});
const FormContextProvider = ({
  children,
  orientation,
  inputSize
}) => {
  const getValue = () => {
    if (orientation === 'horizontal') {
      return {
        orientation,
        inputSize: 'medium'
      };
    }
    return {
      orientation,
      inputSize
    };
  };
  return /*#__PURE__*/React.createElement(FormContext.Provider, {
    value: getValue()
  }, children);
};
const useFormContext = () => {
  const context = useContext(FormContext);
  return context;
};
export { FormContextProvider, useFormContext };